<template>
    <div class="section-dark about-me" id="about-me">
        <div class="container">
            <div class="column is-12 about-me">
                <h1 class="title has-text-centered section-title">About Me</h1>
            </div>
            <div class="columns is-multiline">
                <div class="column is-6 has-vertically-aligned-content" data-aos="fade-right">
                    <p class="is-larger">
                        <strong>
                            I'm an analytical, tech-driven person who is  passionate about new technologies and
                            how to make life easier through businesses and entrepreneurship
                            <!--                                    Since beginning my journey as a freelance designer nearly 10 years ago, I've done remote work for agencies, consulted for startups, and collaborated with talented people to create digital products for both business and consumer use. I'm quietly confident, naturally curious, and perpetually working on improving my chops one design problem at a time.-->
                        </strong>
                    </p>
                    <br/>
                    <p>Worked at Amazon and in 4 Start-Ups, co-founded 2 of them</p>
                    <p>IT-Systems Engineering
                        <a href="https://www.hpi.de/en" target="_blank">@HPI</a></p>
                    <p>E-Businesses
                        <a href="https://www.cbs.dk/en" target="_blank">@CBS</a></p>
                    <br>

                    <div class="is-divider"></div>
                    <div class="columns about-links">
                        <div class="column">
                            <p class="heading">
                                <strong>Email Me</strong>
                            </p>
                            <p class="subheading">
                                p.zimmermann55@gmail.com
                            </p>
                        </div>
                        <div class="column">
                            <p class="heading">
                                <strong>Connect via LinkedIn</strong>
                            </p>
                            <p class="subheading">
                                <a href="https://www.linkedin.com/in/zimmermann-paul" target="_blank">My Profile</a>
                            </p>
                        </div>
                    </div>
                </div>
                <div class="column is-6 right-image is-rounded ">
<!--                    <div class="is-rounded">-->
<!--                    </div>-->
<!--                        src="https://images.pexels.com/photos/669619/pexels-photo-669619.jpeg?auto=compress&cs=tinysrgb&dpr=3&h=750&w=1260"-->
<!--                        alt=""-->
                        <img src="../assets/uncompressed/working.jpg"></img>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "AboutMe"
    }
</script>

<style scoped>

    .about-me {
        margin-top: -2rem;
        padding: 4rem 0 0 1rem !important;
    }
    .column.is-6 {
        /*padding-right: 3rem;*/
    }

    .right-image {
        /*background: linear-gradient(rgba(231, 100, 25, 0.25), rgba(31, 108, 50, 0.5)), rgba(0, 0, 0, 0.55)*/
        /*url("https://images.pexels.com/photos/669619/pexels-photo-669619.jpeg?auto=compress&cs=tinysrgb&dpr=3&h=250&w=250")*/
        /*no-repeat;*/

    }

    .about-links > .column {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
    }

</style>
